module.exports = __webpack_public_path__ + "img/Flipper.2f86ba90.jpg";